import apiClient from '@/services/axios'

export async function get(role) {
    var response = await apiClient.get(`/Idam/RoleLookup/${role}`)
    if (response) {
        return response.data
    }

    throw new Error('Unable to get users for ', role)
}
